import React from 'react';
import {Alert} from "antd";
import {UploadDataPoint} from "../_section/DataPointForm";

function DataForm({upload, inExtWindow, setMortgage}) {
    return (
        <>
            <UploadDataPoint setMortgage={setMortgage} name="iban" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="monthlyPayment" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="startDate" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="endDate" upload={upload} inExtWindow={inExtWindow}/>
            <UploadDataPoint setMortgage={setMortgage} name="closingBalance" upload={upload} inExtWindow={inExtWindow}/>
            <Alert message="Closing balance should always be negative" type="info"/>
        </>
    );


}


export default DataForm;